module.exports = __webpack_public_path__ + "static/media/ruhtinas-blue-bg-gold-200x100.7afc398e.png";